import React, { useEffect, useState, useRef } from 'react';
import style from './TableComponent.module.scss';
import { useDispatch, useSelector } from "react-redux";
import TableModalComponent from './TableModalComponent';
import { showTableModal } from '../../../actions/wizard';
import { ReactComponent as TableIcon } from '../../../assets/icons/Table.svg';

const TableMenu = () => {
  const dispatch = useDispatch();
  const tableTabRef = useRef(null);
  const [rows, setRows] = useState(0);
  const [columns, setColumns] = useState(0);
  const [tableTitle, setTableTitle] = useState('');
  const [tableHeadings, setTableHeadings] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [showEditTable, setShowEditTable] = useState(false);
  const [tableObjDetails, setTableObjDetails] = useState('');
  const showTableCreationModal = useSelector((state: any) => state.wizard.showTableCreationModal);
  const selectedObjects = useSelector((state: any) => state.wizard.selectedObjects);
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const disableTool = pageDetails?.pageType === 'RFQ'

  // Function to show the table modal
  const createTable = () => {
    const newTable = Array.from({ length: rows }, () =>
      Array(columns).fill("")
    );
    setTableTitle('');
    setTableHeadings([]);
    setShowOptions(false);
    setShowEditTable(false);
    setTableObjDetails('');
    dispatch(showTableModal(newTable))
  };

  // Showing edit table button based upon the selection
  useEffect(() => {
    if((selectedObjects?.length === 1) && selectedObjects?.[0]?.tableCode?.length) {
      setShowEditTable(selectedObjects?.[0]?.tableCode);
      setTableTitle(selectedObjects?.[0]?.tableTitle || '');
      setTableHeadings(selectedObjects?.[0]?.tableHeading || []);
      setTableObjDetails(selectedObjects?.[0]?.tableOtherDetails || '');
    } else {
      setShowEditTable(false);
    }
  },[selectedObjects])

  // Closing table creation menu
  useEffect(() => {
    if(showTableCreationModal) {
      setShowEditTable(false);
    }
  },[showTableCreationModal])

  // Handle click outside dropdown to close it
  const handleClickOutside = (event: any) => {
    // Close the export option dropdown
    if (tableTabRef.current && !tableTabRef.current.contains(event.target)) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    // Add event listener to handle click outside the dropdown
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Cleanup the event listener when the component unmounts
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  return (
    <section className={`${style.tableComponent_container} ${disableTool ? 'toolBarDisabledIcon' : '' }`} ref={tableTabRef}>
      <div className={style.table_icon} onClick={() => { setShowOptions(!showOptions)}} >
        <TableIcon />
        <i className={`fa ${showOptions ? 'fa-caret-up' : 'fa-caret-down'}`} />
        {/* {showEditTable ? <i className="fa fa-pencil" aria-hidden="true" onClick={() => { dispatch(showTableModal(showEditTable)); setShowEditTable(false);}}/> : ''} */}
      </div>
      {
        showOptions ? <div className={style.table_creation_dropdown}>
          <p>Number of Row : <input type="number" onChange={(e) => setRows(parseInt(e.target.value))} /></p>
          <p>Number of Column : <input type="number" onChange={(e) => setColumns(parseInt(e.target.value))} /></p>
          <div>
            <span className={style.createBtn} onClick={() => createTable()}>Create</span>
          </div>
        </div> : ''
      }
      {
        showTableCreationModal ? <TableModalComponent title={tableTitle} tableHeadings={tableHeadings} tableObjDetails={tableObjDetails}/> : ''
      }
    </section>
  )
}

export default TableMenu;